(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();

      this.onScrollHandler = this.onScroll.bind(this);
      this.onResizeHandler = this.setHeaderHeight.bind(this);
      this.hideHeaderOnScrollUp = () => {
        this.preventReveal = true;
      };
    }

    connectedCallback() {
      this.header =
        this.closest('.section-header') ||
        document.querySelector('.section-header');

      if (!this.header) {
        return;
      }

      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.headerBounds = {
        top: 0,
        bottom: this.header.offsetHeight
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.preventHide = false;
      this.isScrolling = null;

      this.predictiveSearch =
        this.querySelector('predictive-search');

      this.setHeaderHeight();

      this.mediaQuery = window.matchMedia(
        '(max-width: 990px)'
      );

      if (this.mediaQuery.addEventListener) {
        this.mediaQuery.addEventListener(
          'change',
          this.onResizeHandler
        );
      } else if (this.mediaQuery.addListener) {
        this.mediaQuery.addListener(
          this.onResizeHandler
        );
      }

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add(
          'shopify-section-header-sticky'
        );
      }

      this.addEventListener(
        'preventHeaderReveal',
        this.hideHeaderOnScrollUp
      );

      window.addEventListener(
        'scroll',
        this.onScrollHandler,
        false
      );

      window.addEventListener(
        'resize',
        this.onResizeHandler,
        { passive: true }
      );

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener(
        'preventHeaderReveal',
        this.hideHeaderOnScrollUp
      );

      window.removeEventListener(
        'scroll',
        this.onScrollHandler
      );

      window.removeEventListener(
        'resize',
        this.onResizeHandler
      );

      if (this.mediaQuery) {
        if (this.mediaQuery.removeEventListener) {
          this.mediaQuery.removeEventListener(
            'change',
            this.onResizeHandler
          );
        } else if (this.mediaQuery.removeListener) {
          this.mediaQuery.removeListener(
            this.onResizeHandler
          );
        }
      }
    }

    setHeaderHeight() {
      if (!this.header) {
        return;
      }

      document.documentElement.style.setProperty(
        '--header-height',
        `${this.header.offsetHeight}px`
      );
    }

    createObserver() {
      if (!this.header) {
        return;
      }

      const observer = new IntersectionObserver(
        (entries, currentObserver) => {
          const entry = entries[0];

          if (entry) {
            this.headerBounds = entry.intersectionRect;
          }

          currentObserver.disconnect();
        }
      );

      observer.observe(this.header);
    }

    onScroll() {
      if (!this.header) {
        return;
      }

      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop;

      if (
        this.predictiveSearch &&
        this.predictiveSearch.isOpen
      ) {
        return;
      }

      if (
        scrollTop > this.currentScrollTop &&
        scrollTop > this.headerBounds.bottom
      ) {
        this.header.classList.add(
          'scrolled-past-header'
        );

        if (this.preventHide) {
          this.currentScrollTop = scrollTop;
          return;
        }

        window.requestAnimationFrame(
          this.hide.bind(this)
        );
      } else if (
        scrollTop < this.currentScrollTop &&
        scrollTop > this.headerBounds.bottom
      ) {
        this.header.classList.add(
          'scrolled-past-header'
        );

        if (!this.preventReveal) {
          window.requestAnimationFrame(
            this.reveal.bind(this)
          );
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = window.setTimeout(
            () => {
              this.preventReveal = false;
            },
            66
          );

          window.requestAnimationFrame(
            this.hide.bind(this)
          );
        }
      } else if (
        scrollTop <= this.headerBounds.top
      ) {
        this.header.classList.remove(
          'scrolled-past-header'
        );

        window.requestAnimationFrame(
          this.reset.bind(this)
        );
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (
        this.headerIsAlwaysSticky ||
        !this.header
      ) {
        return;
      }

      this.header.classList.add(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky'
      );

      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (
        this.headerIsAlwaysSticky ||
        !this.header
      ) {
        return;
      }

      this.header.classList.add(
        'shopify-section-header-sticky',
        'animate'
      );

      this.header.classList.remove(
        'shopify-section-header-hidden'
      );
    }

    reset() {
      if (
        this.headerIsAlwaysSticky ||
        !this.header
      ) {
        return;
      }

      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );
    }

    closeMenuDisclosure() {
      if (!this.header) {
        return;
      }

      this.disclosures =
        this.disclosures ||
        this.header.querySelectorAll('header-menu');

      this.disclosures.forEach((disclosure) => {
        if (
          disclosure &&
          typeof disclosure.close === 'function'
        ) {
          disclosure.close();
        }
      });
    }

    closeSearchModal() {
      if (!this.header) {
        return;
      }

      this.searchModal =
        this.searchModal ||
        this.header.querySelector('details-modal');

      if (
        this.searchModal &&
        typeof this.searchModal.close === 'function'
      ) {
        this.searchModal.close(false);
      }
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define(
      'sticky-header',
      StickyHeader
    );
  }

  } catch(e) { console.error(e); }
})();
})();
